import React from 'react';
import { SideTag } from '@/components/ui';
import styles from './OrderManagement.module.css';

interface OrderSectionHeaderProps {
    side: 'buy' | 'sell';
    title: string;
    right?: React.ReactNode;
}

const OrderSectionHeader: React.FC<OrderSectionHeaderProps> = ({ side, title, right }) => (
    <div className={styles['order-section-header']}>
        <div className={styles['order-section-left']}>
            <div className={styles['order-section-accent']} />
            <h2 className={styles['order-section-title']}>{title}</h2>
            <SideTag side={side} colored>{side === 'buy' ? 'Buy' : 'Sell'}</SideTag>
        </div>
        {right && <div className={styles['order-section-actions']}>{right}</div>}
    </div>
);

export default OrderSectionHeader;
